import { gql } from '@apollo/client';

export const UPDATE_USER = gql`
  mutation updateUser(
    $id: ID!
    $firstName: String!
    $lastName: String!
    $occupations: [ID!]
    $isMasaMember: Boolean!
    $recoveryEmail: Email
    $email: Email
    $memberAgency: ID!
    $mobileNumber: String!
    $smsOptIn: Boolean!
    $isMobileNumberVerified: Boolean!
  ) {
    updateUser(
      data: {
        id: $id
        firstName: $firstName
        lastName: $lastName
        recoveryEmail: $recoveryEmail
        email: $email
        occupations: $occupations
        isMasaMember: $isMasaMember
        memberAgency: $memberAgency
        mobileNumber: $mobileNumber
        smsOptIn: $smsOptIn
        isMobileNumberVerified: $isMobileNumberVerified
      }
    ) {
      code
      success
      message
      user {
        id
        firstName
        lastName
        email
        recoveryEmail
        isMasaMember
        emailOpIn {
          receiveEmails
        }
        state {
          id
        }
        memberAgency {
          id
        }
        occupations {
          id
        }
        mobileNumber
        smsOptIn
        isMobileNumberVerified
      }
    }
  }
`;

export const GET_PROFILE_INFO = gql`
  query myUser {
    myUser {
      id
      email
      aliases {
        email
      }
      firstName
      lastName
      isMasaMember
      roles
      recoveryEmail
      emailOpIn {
        receiveEmails
      }
      state {
        id
        name
      }
      occupations {
        id
      }
      memberAgency {
        id
        name
      }
      mobileNumber
      smsOptIn
      isMobileNumberVerified
      mobilePromptReminder
    }
    occupations {
      id
      name
    }
    states {
      id
      name
    }
  }
`;

export const GET_AGENCIES = gql`
  query agencies($stateId: ID!) {
    agencies(filter: { state: $stateId }) {
      id
      name
    }
  }
`;

export const UPDATE_MOBILE_PROMPT_REMINDER = gql`
  mutation UpdateMobilePromptReminder {
    updateMobilePromptReminder {
      success
      message
      user {
        id
        mobilePromptReminder
      }
    }
  }
`;
